import { SchemeTypes } from '../../../../config';
import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  payment_info_label: {
    [LanguagesEnum.English]: 'Payment Info',
    [LanguagesEnum.Greek]: 'Πληροφορίες πληρωμής',
  },
  account_holder_label: {
    [LanguagesEnum.English]: 'Account Holder',
    [LanguagesEnum.Greek]: 'Ιδιοκτήτης Λογαριασμού',
  },
  iban_control: {
    [LanguagesEnum.Greek]: 'IBAN/OBAN',
    [LanguagesEnum.English]: 'IBAN/OBAN',
  },
  no_iban_oban_selected: {
    [LanguagesEnum.Greek]: 'Please select IBAN/OBAN first',
    [LanguagesEnum.English]: 'Please select IBAN/OBAN first',
  },
  iban_help: {
    [LanguagesEnum.English]:
      'In case an IBAN is not available, please select and enter an OBAN',
    [LanguagesEnum.Greek]:
      'In case an IBAN is not available, please select and enter an OBAN',
  },
};

export const CanModify = {
  [SchemeTypes.EU]: (is_agent?: boolean): string[] => {
    return [
      'paymentInfo_iban',
      'paymentInfo_oban',
      'paymentInfo_iban_oban_selection',
      'paymentInfo_accountHolder',
      'paymentInfo_bic',
    ];
  },
  [SchemeTypes.NON_EU]: (is_agent?: boolean): string[] => {
    return [
      'paymentInfo_iban',
      'paymentInfo_oban',
      'paymentInfo_iban_oban_selection',
      'paymentInfo_accountHolder',
      'paymentInfo_bic',
    ];
  },
  [SchemeTypes.IOSS]: (is_agent: boolean): string[] => {
    if (is_agent) {
      return [
        'paymentInfo_iban',
        'paymentInfo_oban',
        'paymentInfo_iban_oban_selection',
        'paymentInfo_accountHolder',
        'paymentInfo_bic',
      ];
    } else {
      return [
        'paymentInfo_iban',
        'paymentInfo_oban',
        'paymentInfo_iban_oban_selection',
        'paymentInfo_accountHolder',
        'paymentInfo_bic',
      ];
    }
  },
};

export default CONFIGURATION;
